export default {
    Close: "Kapat",
    Change: "Değiştir",
    MediaSwitchFailed: "Medya değiştirme başarısız oldu!",
}